export default {
    namespaced: true,
    state: {
        banners: window.regionTorg?.preload?.banners ?? [],
    },
    mutations: {
        setBanners: (state, banners) => state.banners = [...banners]
    },
    actions: {
        fetchBanners: ({state, commit}) => {
            if(state.banners.length > 0) {
                return;
            }
            return axios.get('/banners')
                .then( res => commit('setBanners', res.data.success))
                .catch( err => console.error(err))
        }
    }
}
